import { getWindowInBrowser } from '../../../RuntimeWindow';
import { EventsService } from './eventsServiceTypes';

const lastValues = new Map<string, any>();

export const eventsService: EventsService = {
    dispatch: (type, source, detail) => {
        const key = `${type}-${source}`;
        lastValues.set(key, detail);

        const browserWindow = getWindowInBrowser();
        const customEvent = new CustomEvent<typeof detail>(key, { detail });
        return browserWindow.document.dispatchEvent(customEvent);
    },

    listen(type, source, callback) {
        const key = `${type}-${source}`;
        getWindowInBrowser().document.addEventListener(key, callback as any);
        return () =>
            getWindowInBrowser().document.removeEventListener(
                key,
                callback as any
            );
    },

    listenWithReplay(type, source, callback) {
        const disposer = eventsService.listen(type, source, callback);

        const key = `${type}-${source}`;
        const lastValue = lastValues.get(key);

        if (lastValue !== undefined) {
            queueMicrotask(() => {
                const syntheticEvent = new CustomEvent(key, {
                    detail: lastValue,
                });
                callback(syntheticEvent as any);
            });
        }

        return disposer;
    },
};
